var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',{attrs:{"bubble-icon":{
    icon: _vm.Icon.CircleDot,
    colour: 'default',
  },"header":_vm.$t('modal.heading.withdrawOpenShiftResponse'),"primary-button":{
    label: _vm.$t('button.withdrawOpenShiftResponse'),
    colour: 'pink',
    action: () => _vm.withdrawResponse(),
  },"secondary-action":{
    label: _vm.$t('button.cancel'),
    action: () => (_vm.open = false),
    colour: 'transparent',
  }},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('OpenShiftResponseDetails',{attrs:{"shift":_vm.shift}})]},proxy:true}]),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }